import styled from '@emotion/styled';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Box, Button, Divider, FormControl, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { GridDeleteIcon } from '@mui/x-data-grid';

import TxtVereadorSite from '../../../../autoComplete/TxtVereador';
import { ISvereador, Vereador } from '../../../../../typesSite/vereador/Vereador';
import { useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { useSnackbar } from 'notistack';
import { PublicacaoOficialVereadorList } from '../types/PublicacaoOficialVereador';
 

interface Props {
  vereadores: PublicacaoOficialVereadorList[];
  setVerador: (vereadores: PublicacaoOficialVereadorList[]) => void;
}

export default function PublicacaoOficialVereadorListComponent({ vereadores, setVerador }: Props) {
  

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [vereadorSelecionado, SetvereadorSelecionado] = useState<Vereador>(ISvereador);
  const handletxtTipoPublicacaoOficialChange = (vereador: Vereador) => {
    SetvereadorSelecionado(vereador);
  };

  const onDeleteAll = () => {
    const novosVereadores = vereadores.map(it => ({
      ...it,
      excluido: true
    }));
    setVerador(novosVereadores);
  };

  const onDeleteVereador = (index: number) => {
    const novosVereadores = [...vereadores];
    novosVereadores[index].excluido = true;
    setVerador(novosVereadores);
  };

  const adicionarVereador = (vereador: Vereador) => {
    if (!vereador || !vereador.id) {
       enqueueSnackbar('Vereador não encontrado!', { variant: 'error' });
      return;
    }

    const jaAdicionado = vereadores.find(it => it.vereador.id === vereador.id && !it.excluido);
    if (jaAdicionado) {
        enqueueSnackbar('Vereador já incluído!', { variant: 'error' });
      return;
    }
    const novoVereador: PublicacaoOficialVereadorList = {
      id: '',      
      publicacaoOficial: '',
      vereador: vereador,
      excluido: false
    };

    const novosVereadores = [...vereadores, novoVereador];
    setVerador(novosVereadores);
    SetvereadorSelecionado(ISvereador);
  };

  return (
    <Box>
      {/* Campo de busca + botão */}
      <Box mt={2} display="flex" alignItems="center" gap={2}>
        <FormControl fullWidth>
          <TxtVereadorSite
            isdisabled={false}
            value={vereadorSelecionado}
            handleSearchChange={it => {
              handletxtTipoPublicacaoOficialChange(it);
            }}
          />
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => adicionarVereador(vereadorSelecionado)}
          sx={{
            whiteSpace: 'nowrap',
            height: '40px',
            px: 3
          }}
        >
          Adicionar
        </Button>
      </Box>

      {/* Lista de vereadores */}
      <List dense sx={{ mt: 1, p: 0 }}>
        {vereadores?.map(
          (file, i) =>
            !file.excluido && (
              <ListItem
                key={i}
                disablePadding
                sx={{
                  px: 1.5,
                  py: 0.5,
                  borderBottom: '1px solid #eee'
                }}
              >
                <ListItemText primary={file.vereador.nome} sx={{ m: 0 }} />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="delete" onClick={() => onDeleteVereador(i)} size="small">
                    <GridDeleteIcon color="error" fontSize="small" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            )
        )}
      </List>

      {/* Botão Excluir Todos */}
      {vereadores?.length > 0 && (
        <Box display="flex" justifyContent="flex-end" mt={2}>
          <Divider flexItem sx={{ mr: 2, alignSelf: 'center' }} />
          <Button onClick={onDeleteAll} color="error" variant="outlined" size="small">
            Excluir todos
          </Button>
        </Box>
      )}
    </Box>
  );
}
